/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";
import CookieConsent from "react-cookie-consent";

function DarkFooter() {
  return (
    <footer className="footer" data-background-color="black">
      <Container>
        <nav>
          <ul>
            <li>
              <a href="#" target="_blank">
                FIBS Global Conference
              </a>
            </li>
            <li>
              <a href="#" target="_blank">
                About Us
              </a>
            </li>
            <li>
              <a href="/privacy-policy">Privacy Policy</a>
            </li>
          </ul>
        </nav>
        <div className="copyright" id="copyright">
          <p className="mb-0">© {new Date().getFullYear()} FIBS Logistics</p>
        </div>
      </Container>
      <CookieConsent
        containerClasses="cookies-fibs"
        contentClasses="cookies-fibs-content"
        disableStyles={true}
      >
        This website uses cookies to enhance the user experience.
      </CookieConsent>
    </footer>
  );
}

export default DarkFooter;
